module.exports = __webpack_public_path__ + "img/1581458942.26f51e1d.jpg";